module.exports = __webpack_public_path__ + "static/media/paper.d8f3945f.svg";